import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  title: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#465869"
  }
}));

export default styles;
